import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    // primary: {
    // main: '',
    // light: '',
    // dark: '',
    // contrastText: '',
    // },
    // secondary: {
    // },
    // success: {
    // },
  },
  typography: {
    //   h1: {},
    h2: {
      fontSize: 40,
      fontWeight: 700,
      color: 'white',
    },
    h3: {
      fontSize: 30,
      fontWeight: 700,
      color: 'white',
    },
    h4: {
      fontSize: 16,
      fontWeight: 700,
      color: 'white',
    },
    h5: {
      fontSize: 14,
      fontWeight: 400,
      color: 'white',
    },
    // h6: {

    // },
    subtitle1: {
      fontSize: 12,
      fontWeight: 400,
      color: 'white',
      width: 'max-content',
    },
    subtitle2: {
      fontSize: 14,
      fontWeight: 400,
      color: 'gray',
      width: 'max-content',
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          background: '#25272B',
          borderRadius: 4,
          fontSize: 14,
          fontWeight: 400,
          padding: 14,
          color: '#FFFFFF',
          // lineHeight: 20,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '10px',
          height: 30,
        },
      },
    },
    // MuiSelect:{
    //   styleOverrides:{

    //   }
    // },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          textTransform: 'none',
          height: '40px !important',
        },
        containedPrimary: {
          minWidth: '150px',
          background: '#FF3839',
          color: 'white',
          fontSize: 14,
          fontWeight: 700,
          ':hover': {
            background: '#FF3839',
            color: 'white',
          },
        },
        outlinedPrimary: {
          minWidth: '150px',
          background: 'transparent',
          color: '#FF3839',
          fontSize: 14,
          fontWeight: 700,
          border: 'none',
          ':hover': {
            background: 'transparent',
            color: '#FF3839',
            border: 'none',
          },
        },
        containedSecondary: {
          minWidth: '150px',
          color: '#FF3839',
          background: 'white',
          fontSize: 14,
          fontWeight: 700,
          ':hover': {
            color: '#FF3839',
            background: 'white',
          },
        },
      },
    },
    // MuiPaper:{
    //   styleOverrides:{
    //     root:{
    //       backgroundColor: '#111111',
    //       color:'white'
    //     }
    //   }
    // }
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: 'white',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        colorPrimary: {
          color: '#FF3839',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          color: 'white',
        },
        page: {
          border: '1px solid #ffffff66',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          padding: '8px',
          fontSize: 12,
          fontWeight: 700,
        },
        colorError: {
          background: '#FF3B3024',
          color: '#FF3B30',
        },
        colorSuccess: {
          background: '#59A30424',
          color: '#4BB543',
        },
        colorWarning: {
          background: '#8B8000',
          color: 'yellow',
        },
        colorSecondary: {
          background: '#CCCCCC',
          color: '#171717',
        },
      },
    },

    MuiTab: {
      styleOverrides: {
        root: {
          color: 'white',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        colorPrimary: {
          color: 'white',
        },
      },
    },
    MuiSwitch:{
      styleOverrides:{
        track:{
          border:'2px solid white',
          height:15
        }
      }
    }
  },
})

export default theme
